export default __webpack_public_path__ + "static/media/ellipsis.b3444452.svg";